import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/site/Reveal";

export default function CTABanner() {
  return (
    <section data-testid="home-cta-banner" className="bg-ivory border-t border-warmGray/15">
      <div className="container-editorial py-20 lg:py-28">
        <Reveal>
          <div className="grid grid-cols-1 md:grid-cols-12 items-end gap-10 lg:gap-14 max-w-5xl mx-auto">
            <div className="md:col-span-8">
              <p className="overline mb-5">Begin</p>
              <p className="font-serif text-navy text-3xl md:text-4xl lg:text-[2.6rem] leading-[1.18]">
                Let's create a strategy that gives you back your time —{" "}
                <em className="font-serif italic text-sage">and builds your wealth.</em>
              </p>
            </div>
            <div className="md:col-span-4 md:text-right flex flex-col md:items-end gap-5">
              {/* Sage availability badge — integrated next to the CTA */}
              <span className="inline-flex items-center gap-2.5 bg-sage/12 border border-sage/35 text-sage rounded-full px-4 py-2 font-ui uppercase tracking-[0.16em] text-[12px] font-semibold">
                <span className="block w-1.5 h-1.5 rounded-full bg-sage animate-[pulse_3s_ease-in-out_infinite]" />
                Currently booking Q3
              </span>
              <Link to="/contact" data-testid="cta-banner-work-with-me" className="btn-primary">
                Work With Me <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
